(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2624,5442,5223,7907,4231],{

/***/ 14504:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_sites/[mobileOrDesktop]/[hostname]",
      function () {
        return __webpack_require__(98544);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 19060:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SsgFallback; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_Loading__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69528);
/* harmony import */ var _packages_justo_parts_lib_components_Container__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59848);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80805);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_4__);





function SsgFallback() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_packages_justo_parts_lib_components_Container__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_4___default().container),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Loading__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_4___default().loading)
        })
    });
};


/***/ }),

/***/ 53762:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Loading; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8165);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_2__);



function Loading(props) {
    var height = props.height || 200;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_2___default().container),
        style: {
            height: height
        }
    });
};


/***/ }),

/***/ 1555:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _codebuild_output_src3436485638_src_codestar_connections_us_east_1_amazonaws_com_git_http_765846071129_us_east_1_2b8358da_528f_4cea_9fc4_c84ee5141e4b_getjusto_justo_services_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _codebuild_output_src3436485638_src_codestar_connections_us_east_1_amazonaws_com_git_http_765846071129_us_east_1_2b8358da_528f_4cea_9fc4_c84ee5141e4b_getjusto_justo_services_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_codebuild_output_src3436485638_src_codestar_connections_us_east_1_amazonaws_com_git_http_765846071129_us_east_1_2b8358da_528f_4cea_9fc4_c84ee5141e4b_getjusto_justo_services_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useIsDarkMode__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54731);
/* harmony import */ var _hooks_useKeyboardEvent__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1626);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _loadingIndicators_Spinner__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(18899);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}








function Button(props, ref) {
    var _$ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), loadingState = _$ref[0], setLoading = _$ref[1];
    var buttonRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var loading = props.loading || loadingState;
    var _$ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), confirm = _$ref1[0], setConfirm = _$ref1[1];
    var overrideOnClickRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)();
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_6__.useRouter)();
    var darkMode = (0,_hooks_useIsDarkMode__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    var onClick = function() {
        var _ref = _asyncToGenerator(_codebuild_output_src3436485638_src_codestar_connections_us_east_1_amazonaws_com_git_http_765846071129_us_east_1_2b8358da_528f_4cea_9fc4_c84ee5141e4b_getjusto_justo_services_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            return _codebuild_output_src3436485638_src_codestar_connections_us_east_1_amazonaws_com_git_http_765846071129_us_east_1_2b8358da_528f_4cea_9fc4_c84ee5141e4b_getjusto_justo_services_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(props.disabled || loading)) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        if (!props.confirmText) {
                            _ctx.next = 9;
                            break;
                        }
                        if (!confirm) {
                            _ctx.next = 7;
                            break;
                        }
                        {
                            setConfirm(false);
                        }
                        _ctx.next = 9;
                        break;
                    case 7:
                        setConfirm(true);
                        return _ctx.abrupt("return");
                    case 9:
                        setLoading(true);
                        if (!overrideOnClickRef.current) {
                            _ctx.next = 15;
                            break;
                        }
                        _ctx.next = 13;
                        return overrideOnClickRef.current();
                    case 13:
                        _ctx.next = 21;
                        break;
                    case 15:
                        if (!props.onClick) {
                            _ctx.next = 20;
                            break;
                        }
                        _ctx.next = 18;
                        return props.onClick();
                    case 18:
                        _ctx.next = 21;
                        break;
                    case 20:
                        if (props.to) {
                            router.push(props.to);
                        }
                    case 21:
                        // check if button is mounted
                        if (buttonRef.current) {
                            setLoading(false);
                        }
                    case 22:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onClick() {
            return _ref.apply(this, arguments);
        };
    }();
    var setOnClick = function(onClick) {
        overrideOnClickRef.current = onClick;
    };
    var _clickOnKey;
    (0,_hooks_useKeyboardEvent__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((_clickOnKey = props.clickOnKey) !== null && _clickOnKey !== void 0 ? _clickOnKey : "none", function() {
        if (!props.disabled && !loading && props.clickOnKey) {
            onClick();
        }
    });
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useImperativeHandle)(ref, function() {
        return {
            onClick: onClick,
            setOnClick: setOnClick,
            click: onClick,
            focus: function() {
                if (buttonRef.current) {
                    buttonRef.current.focus();
                }
            }
        };
    });
    var style = props.disabled ? "disabled" : props.primary ? "primary" : props.danger ? "danger" : props.contrast ? "contrast" : "default";
    var size = props.small ? "small" : props.extraBig ? "extraBig" : props.big ? "big" : "default";
    var className = classnames__WEBPACK_IMPORTED_MODULE_5___default()({
        "inline-flex justify-center items-center shadow-sm rounded": true,
        "font-semibold": true,
        "transition ease-in-out duration-150": true,
        "focus:outline-none focus:ring-2 focus:ring-offset-2": true,
        "px-4 py-2 text-sm": size === "default",
        "px-4 py-1 text-sm": size === "small",
        "px-5 py-3 text-md": size === "big",
        "px-5 py-4 text-md": size === "extraBig",
        "cursor-not-allowed": props.disabled,
        "w-full": props.full,
        "!border-gray-100 text-gray-400": style === "disabled",
        "border-gray-100 text-gray-700": style === "default",
        "text-white": style === "primary" || style === "danger",
        "focus:ring-gray-300": style === "default",
        "focus:button-v3-primary": style === "primary",
        "focus:ring-red-500": style === "danger",
        "bg-gray-100 border-gray-100": style === "disabled" || style === "default",
        "bg-red-500 border-red-500": style === "danger",
        "button-v3-primary": style === "primary",
        "bg-gray-900 border-gray-900 text-white": style === "contrast" && !darkMode,
        "bg-white border-white text-gray-900": style === "contrast" && darkMode,
        "hover:bg-gray-200": !loading && style === "default" || style === "contrast" && darkMode && !loading,
        "hover:button-v3-primary": !loading && style === "primary",
        "hover:bg-red-400": !loading && style === "danger",
        "hover:bg-gray-300": style === "contrast" && !darkMode && !loading
    }, props.className);
    var _type;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("button", {
        ref: buttonRef,
        type: (_type = props.type) !== null && _type !== void 0 ? _type : "submit",
        form: "formId",
        disabled: props.disabled || loading,
        onClick: onClick,
        className: className,
        children: [
            !loading && props.icon ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(props.icon, {
                className: "-ml-0.5 mr-2 w-4",
                "aria-hidden": "true"
            }) : null,
            loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_loadingIndicators_Spinner__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                className: "mr-3",
                color: style === "default" ? "gray" : "white"
            }) : null,
            confirm ? props.confirmText : props.children
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)(Button));


/***/ }),

/***/ 18899:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SpinnerLoading; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);


function SpinnerLoading(props) {
    var color = props.color || "gray";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(props.className, {
            "h-5 w-5": !props.size || props.size === "sm",
            "h-4 w-4": props.size === "xs",
            "h-6 w-6": props.size === "md",
            "h-8 w-8": props.size === "lg",
            "h-10 w-10": props.size === "xl",
            "animate-spin": true,
            "text-white": color === "white",
            "text-gray-500": color === "gray",
            "text-blue-500": color === "blue" || color === "primary",
            "text-green-500": color === "green",
            "text-red-500": color === "red",
            "text-yellow-500": color === "yellow",
            "text-black": color === "black"
        }),
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                className: "opacity-25",
                cx: "12",
                cy: "12",
                r: "10",
                stroke: "currentColor",
                strokeWidth: "4"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "opacity-75",
                fill: "currentColor",
                d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            })
        ]
    });
};


/***/ }),

/***/ 1626:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useKeyboardEvent; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function useKeyboardEvent(combination, callback) {
    var keysToMatch = combination.toLowerCase().split("+");
    var keys = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({}).current;
    var callbackRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    callbackRef.current = callback;
    var checkEvent = function() {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = keysToMatch[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var keyToMatch = _step.value;
                if (!keys[keyToMatch]) return;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        callbackRef.current();
    };
    var onKeyDown = function(event) {
        if (event && event.key) {
            var key = event.key.toLowerCase();
            keys[key] = true;
        }
    };
    var onKeyUp = function(event) {
        if (event && event.key) {
            checkEvent();
            var key = event.key.toLowerCase();
            delete keys[key];
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        document.addEventListener("keyup", onKeyUp);
        document.addEventListener("keydown", onKeyDown);
        return function() {
            document.removeEventListener("keyup", onKeyUp);
            document.removeEventListener("keydown", onKeyDown);
        };
    });
};


/***/ }),

/***/ 5528:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useMessage; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _packages_justo_parts_lib_contexts_ShowMessageContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59325);


function useMessage() {
    var showMessage = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_packages_justo_parts_lib_contexts_ShowMessageContext__WEBPACK_IMPORTED_MODULE_1__["default"]);
    return showMessage;
};


/***/ }),

/***/ 25932:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useTrack; }
/* harmony export */ });
/* harmony import */ var _codebuild_output_src3436485638_src_codestar_connections_us_east_1_amazonaws_com_git_http_765846071129_us_east_1_2b8358da_528f_4cea_9fc4_c84ee5141e4b_getjusto_justo_services_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _codebuild_output_src3436485638_src_codestar_connections_us_east_1_amazonaws_com_git_http_765846071129_us_east_1_2b8358da_528f_4cea_9fc4_c84ee5141e4b_getjusto_justo_services_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_codebuild_output_src3436485638_src_codestar_connections_us_east_1_amazonaws_com_git_http_765846071129_us_east_1_2b8358da_528f_4cea_9fc4_c84ee5141e4b_getjusto_justo_services_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var apollo_hooks__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3172);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50456);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}

function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n          mutation trackAction(\n            $type: String\n            $productId: ID\n            $orderId: ID\n            $path: String\n            $meta: JSON\n          ) {\n            trackAction(\n              type: $type\n              productId: $productId\n              orderId: $orderId\n              path: $path\n              meta: $meta\n            )\n          }\n        "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


function useTrack() {
    var mutate = (0,apollo_hooks__WEBPACK_IMPORTED_MODULE_1__/* .useMutate */ .Tu)();
    var track = function() {
        var _ref = _asyncToGenerator(_codebuild_output_src3436485638_src_codestar_connections_us_east_1_amazonaws_com_git_http_765846071129_us_east_1_2b8358da_528f_4cea_9fc4_c84ee5141e4b_getjusto_justo_services_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(type, params) {
            return _codebuild_output_src3436485638_src_codestar_connections_us_east_1_amazonaws_com_git_http_765846071129_us_east_1_2b8358da_528f_4cea_9fc4_c84ee5141e4b_getjusto_justo_services_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return mutate({
                            mutation: (0,graphql_tag__WEBPACK_IMPORTED_MODULE_2__["default"])(_templateObject()),
                            variables: _objectSpread({}, params, {
                                type: type
                            })
                        });
                    case 3:
                        _ctx.next = 7;
                        break;
                    case 5:
                        _ctx.prev = 5;
                        _ctx.t0 = _ctx["catch"](0);
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    5
                ]
            ]);
        }));
        return function track(type, params) {
            return _ref.apply(this, arguments);
        };
    }();
    return track;
};


/***/ }),

/***/ 23023:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Example; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_icons_md__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5434);
/* harmony import */ var _components_V3_Button__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1555);



function Example() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "min-h-full bg-white px-4 py-16 sm:px-6 sm:py-24 md:grid md:place-items-center lg:px-8",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "mx-auto max-w-max",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("main", {
                    className: "sm:flex",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-4xl font-bold tracking-tight text-indigo-600 sm:text-5xl",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_2__/* .MdWifiOff */ .Em6, {})
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "sm:ml-6",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "sm:border-l sm:border-gray-200 sm:pl-6",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                            className: "text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl",
                                            children: "Este sitio esta desactivado"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "mt-1 text-base text-gray-500",
                                            children: "Para activarlo, contacta a cobranzas@getjusto.com"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "mt-10 flex space-x-3 sm:border-l sm:border-transparent sm:pl-6",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_V3_Button__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                        primary: true,
                                        onClick: function() {
                                            return window.location.href = "https://getjusto.com";
                                        },
                                        children: "Ir a Justo"
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};


/***/ }),

/***/ 25442:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ NoWebsite; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43469);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_2__);



function NoWebsite(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_2___default().container),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: "/images/no-website.svg",
                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_2___default().image)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_2___default().title),
                children: "Este sitio web no est\xe1 configurado correctamente"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                    href: "https://getjusto.com",
                    className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_2___default().logo),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: "/logo-dark.svg"
                    })
                })
            })
        ]
    });
};


/***/ }),

/***/ 57907:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Page; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./src/components/componentTypes/index.ts

var ContactForm = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3662), __webpack_require__.e(5445), __webpack_require__.e(5990), __webpack_require__.e(6907), __webpack_require__.e(4053), __webpack_require__.e(6350), __webpack_require__.e(191), __webpack_require__.e(5837), __webpack_require__.e(7502), __webpack_require__.e(791), __webpack_require__.e(9773), __webpack_require__.e(3269), __webpack_require__.e(8695), __webpack_require__.e(9207), __webpack_require__.e(7605), __webpack_require__.e(8688)]).then(__webpack_require__.bind(__webpack_require__, 82109));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(82109)
            ];
        }
    }
});
var CoverManager = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4829).then(__webpack_require__.bind(__webpack_require__, 24829));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(24829)
            ];
        }
    }
});
var Custom = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5990), __webpack_require__.e(707), __webpack_require__.e(7212)]).then(__webpack_require__.bind(__webpack_require__, 7212));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(7212)
            ];
        }
    }
});
var DeliveryZone = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5990), __webpack_require__.e(6907), __webpack_require__.e(4053), __webpack_require__.e(6350), __webpack_require__.e(929)]).then(__webpack_require__.bind(__webpack_require__, 47266));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(47266)
            ];
        }
    }
});
var Faq = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5445), __webpack_require__.e(9654)]).then(__webpack_require__.bind(__webpack_require__, 99654));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(99654)
            ];
        }
    }
});
var FeaturedCategories = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5990), __webpack_require__.e(2012)]).then(__webpack_require__.bind(__webpack_require__, 67758));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(67758)
            ];
        }
    }
});
var FullImageWithMessage = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5990), __webpack_require__.e(6907), __webpack_require__.e(4053), __webpack_require__.e(6350), __webpack_require__.e(6172)]).then(__webpack_require__.bind(__webpack_require__, 55638));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(55638)
            ];
        }
    }
});
var Gallery = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5990), __webpack_require__.e(586)]).then(__webpack_require__.bind(__webpack_require__, 7063));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(7063)
            ];
        }
    }
});
var Hero = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5990), __webpack_require__.e(7312)]).then(__webpack_require__.bind(__webpack_require__, 65372));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(65372)
            ];
        }
    }
});
var ImageWithMessage = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5990), __webpack_require__.e(9141)]).then(__webpack_require__.bind(__webpack_require__, 69650));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(69650)
            ];
        }
    }
});
var Instagram = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 903).then(__webpack_require__.bind(__webpack_require__, 40903));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(40903)
            ];
        }
    }
});
var JustAnImage = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5990), __webpack_require__.e(3075)]).then(__webpack_require__.bind(__webpack_require__, 6887));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6887)
            ];
        }
    }
});
var Links = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 2125).then(__webpack_require__.bind(__webpack_require__, 62125));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(62125)
            ];
        }
    }
});
var MultiImageWithMessage = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5990), __webpack_require__.e(853)]).then(__webpack_require__.bind(__webpack_require__, 55540));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(55540)
            ];
        }
    }
});
var Popup = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5990), __webpack_require__.e(6907), __webpack_require__.e(4053), __webpack_require__.e(6350), __webpack_require__.e(1047), __webpack_require__.e(1214)]).then(__webpack_require__.bind(__webpack_require__, 31674));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(31674)
            ];
        }
    }
});
var ProductShowcase = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4246).then(__webpack_require__.bind(__webpack_require__, 74246));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(74246)
            ];
        }
    }
});
var Publications = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 755).then(__webpack_require__.bind(__webpack_require__, 40755));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(40755)
            ];
        }
    }
});
var Redirect = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9783).then(__webpack_require__.bind(__webpack_require__, 89783));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(89783)
            ];
        }
    }
});
var Referrals = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4646).then(__webpack_require__.bind(__webpack_require__, 74646));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(74646)
            ];
        }
    }
});
var Slider = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5990), __webpack_require__.e(4761), __webpack_require__.e(5608)]).then(__webpack_require__.bind(__webpack_require__, 69378));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(69378)
            ];
        }
    }
});
var StartOrdering = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3662), __webpack_require__.e(5445), __webpack_require__.e(5990), __webpack_require__.e(6907), __webpack_require__.e(4053), __webpack_require__.e(6350), __webpack_require__.e(191), __webpack_require__.e(5837), __webpack_require__.e(7502), __webpack_require__.e(791), __webpack_require__.e(9773), __webpack_require__.e(3269), __webpack_require__.e(8695), __webpack_require__.e(8240), __webpack_require__.e(9207), __webpack_require__.e(7605), __webpack_require__.e(3006)]).then(__webpack_require__.bind(__webpack_require__, 41395));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(41395)
            ];
        }
    }
});
var StoreLocator = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3662), __webpack_require__.e(5445), __webpack_require__.e(5990), __webpack_require__.e(6907), __webpack_require__.e(4053), __webpack_require__.e(6350), __webpack_require__.e(191), __webpack_require__.e(5837), __webpack_require__.e(7502), __webpack_require__.e(9773), __webpack_require__.e(3269), __webpack_require__.e(9207), __webpack_require__.e(7370), __webpack_require__.e(5299)]).then(__webpack_require__.bind(__webpack_require__, 72814));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(72814)
            ];
        }
    }
});
var Stores = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5990), __webpack_require__.e(4053), __webpack_require__.e(4944)]).then(__webpack_require__.bind(__webpack_require__, 63661));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(63661)
            ];
        }
    }
});
var WhiteSpace = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 213).then(__webpack_require__.bind(__webpack_require__, 70213));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(70213)
            ];
        }
    }
});
/* harmony default export */ var componentTypes = ({
    custom: Custom,
    coverManager: CoverManager,
    justAnImage: JustAnImage,
    gallery: Gallery,
    redirect: Redirect,
    hero: Hero,
    popup: Popup,
    featuredCategories: FeaturedCategories,
    startOrdering: StartOrdering,
    deliveryZone: DeliveryZone,
    slider: Slider,
    imageWithMessage: ImageWithMessage,
    links: Links,
    stores: Stores,
    faq: Faq,
    referrals: Referrals,
    contactForm: ContactForm,
    multiImageWithMessage: MultiImageWithMessage,
    whiteSpace: WhiteSpace,
    publications: Publications,
    instagram: Instagram,
    fullImageWithMessage: FullImageWithMessage,
    productShowcase: ProductShowcase,
    storeLocator: StoreLocator
});

// EXTERNAL MODULE: ./src/components/SafeSuspense/index.tsx
var SafeSuspense = __webpack_require__(5822);
// EXTERNAL MODULE: ./src/components/SuspenseLoading/Loading.tsx
var Loading = __webpack_require__(53762);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 1 modules
var lib = __webpack_require__(50456);
;// CONCATENATED MODULE: ./src/data/fragments/website/pageFragment.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  fragment pageComponents on Page {\n    _id\n    path\n    disabled\n    activeComponents {\n      _id\n      options\n      componentTypeId\n      schedule {\n        isScheduled\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var pageFragment = ((0,lib["default"])(_templateObject()));

// EXTERNAL MODULE: ./src/providers/apollo/getClient.ts
var apollo_getClient = __webpack_require__(98751);
;// CONCATENATED MODULE: ./src/data/queries/page/getWebsitePage.ts
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function getWebsitePage_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}

function getWebsitePage_templateObject() {
    var data = getWebsitePage_taggedTemplateLiteral([
        "\n  query getWebsitePage_cached($pageId: ID, $websiteId: ID) {\n    page(pageId: $pageId, websiteId: $websiteId) {\n      ...pageComponents\n    }\n  }\n  ",
        "\n"
    ]);
    getWebsitePage_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var getWebsitePageQuery = (0,lib["default"])(getWebsitePage_templateObject(), pageFragment);
function getWebsitePage(websiteId, pageId) {
    return _getWebsitePage.apply(this, arguments);
};
function _getWebsitePage() {
    _getWebsitePage = _asyncToGenerator(regeneratorRuntime.mark(function _callee(websiteId, pageId) {
        var data;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return getClient().query({
                        query: getWebsitePageQuery,
                        variables: {
                            pageId: pageId,
                            websiteId: websiteId
                        }
                    });
                case 2:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data.page);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _getWebsitePage.apply(this, arguments);
}

// EXTERNAL MODULE: ./src/helpers/logger/index.ts + 2 modules
var logger = __webpack_require__(80251);
// EXTERNAL MODULE: ./src/hooks/useEffect.ts
var useEffect = __webpack_require__(10338);
// EXTERNAL MODULE: ./src/hooks/useTrack.ts
var useTrack = __webpack_require__(25932);
// EXTERNAL MODULE: ./src/hooks/useWebsiteId.ts
var useWebsiteId = __webpack_require__(16825);
// EXTERNAL MODULE: ./node_modules/apollo-hooks/dist/apollo-hooks.es.js
var apollo_hooks_es = __webpack_require__(3172);
;// CONCATENATED MODULE: ./src/page-components/Page/index.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}











var SuspenseFallback = function(param) {
    var componentTypeId = param.componentTypeId;
    logger/* default.error */.Z.error("Suspense gatillado para componente SSR (".concat(componentTypeId, "). Esto es un error de implementaci\xf3n. Revisar que el componente no est\xe9 usando una query que no sea partial."));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {});
};
function Page(props) {
    var page = props.page;
    var _componentIdToSsrProps = props.componentIdToSsrProps, componentIdToSsrProps = _componentIdToSsrProps === void 0 ? {} : _componentIdToSsrProps;
    var websiteId = (0,useWebsiteId/* default */.Z)();
    var pageResults = (0,apollo_hooks_es/* useApolloQuery */.Zu)({
        query: getWebsitePageQuery,
        variables: {
            pageId: props.pageId,
            websiteId: websiteId
        },
        partial: true,
        omit: !!page
    });
    if (pageResults === null || pageResults === void 0 ? void 0 : pageResults.page) {
        page = pageResults.page;
    }
    var track = (0,useTrack/* default */.Z)();
    (0,useEffect/* default */.Z)(function() {
        if (page) {
            track("viewPage", {
                path: page.path
            });
        }
    }, [
        page === null || page === void 0 ? void 0 : page._id
    ]);
    if (!page) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: page.activeComponents.map(function(component) {
            var Component = componentTypes[component.componentTypeId];
            var __id;
            var ssrProps = (__id = componentIdToSsrProps[component._id]) !== null && __id !== void 0 ? __id : {};
            if (!Component) return "Component ".concat(component.componentTypeId, " not found");
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "ct-".concat(component.componentTypeId),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SafeSuspense/* default */.Z, {
                    fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)(SuspenseFallback, {
                        componentTypeId: component.componentTypeId
                    }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, _objectSpread({}, component.options, ssrProps, {
                        id: component._id
                    }))
                })
            }, component._id);
        })
    });
};


/***/ }),

/***/ 98544:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ PagesPage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_SsgFallback__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19060);
/* harmony import */ var _page_components_DeactivatedByDebt__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23023);
/* harmony import */ var _page_components_Layout_AbstractLayout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37954);
/* harmony import */ var _page_components_Layout_Website__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(20151);
/* harmony import */ var _page_components_NoWebsite__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25442);
/* harmony import */ var _page_components_Page__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(57907);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_7__);








var __N_SSG = true;
function PagesPage(props) {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_7__.useRouter)();
    if (router.isFallback) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_SsgFallback__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {});
    }
    if (!props.website) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_page_components_NoWebsite__WEBPACK_IMPORTED_MODULE_5__["default"], {});
    }
    if (props.website.isDeactivatedByDebt) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_page_components_DeactivatedByDebt__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {});
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_page_components_Layout_AbstractLayout__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        LayoutComponent: _page_components_Layout_Website__WEBPACK_IMPORTED_MODULE_4__["default"],
        initialData: props.initialData,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_page_components_Page__WEBPACK_IMPORTED_MODULE_6__["default"], {
            pageId: props.page._id,
            page: props.page,
            componentIdToSsrProps: props.componentIdToSsrProps
        })
    });
};


/***/ }),

/***/ 80805:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_2k40sP--bs7-ORleL6riGA","loading":"_2eozYEUmcZzMsjXiI6UIu6"};

/***/ }),

/***/ 8165:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_3dzszu0edT56nvw27R-vYR loadingGlow"};

/***/ }),

/***/ 43469:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_3uvgfwBWaWQqFyLab9Dtip","image":"hS9SabcUKdHLsU7xUWYeA","title":"_3zsZZ1G9oclG4rKZNszc97","logo":"_1EDR5Wb9Y0TBlQji0Ya33U"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1228,1470,4078,1964,3067,4356,6970,937,7954,151,9774,2888,179], function() { return __webpack_exec__(14504); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);